import { isReservedRouteSegment } from '@seaters/constants';

export const getSlugFromUrl = (): string | null => {
  const url = window.location.pathname;

  const hash = window.location.hash;

  // Legacy AngularJS hash-bang migration: a URL like `/#!/kpn/landing` is
  // rewritten to the real path `/kpn/landing`. Only fire for genuine hash-bang
  // URLs (hash starts with `#!`). The previous guard (`hash && url === '/'`)
  // re-navigated to a URL that still had a bare `#…` fragment and a `/` path, so
  // the condition never cleared and `window.open(sameUrl, '_self')` reloaded the
  // same page forever (RangeError: Maximum call stack size exceeded, iOS WebKit).
  if (url === '/' && hash.startsWith('#!')) {
    const migratedPath = hash.slice(2) || '/';
    // Collapse any leading run of slashes — forward OR back — to exactly one
    // forward slash. Without this a fragment like `#!//example.com` yields
    // `//example.com`, which `window.location.replace` treats as a
    // protocol-relative URL and navigates off-origin (open redirect). Backslashes
    // must be included because browsers normalize `\` to `/` when resolving
    // http(s) URLs, so `#!/\/evil.com` would otherwise slip through as `//evil.com`.
    // Forcing a single leading forward slash keeps the target a same-origin path.
    const normalizedPath = `/${migratedPath}`.replace(/^[\\/]+/, '/');
    window.location.replace(`${normalizedPath}${window.location.search}`);
    return null;
  }

  const slug = url.split('/')[1];

  const querySlug = new URLSearchParams(window.location.search).get(
    'fanGroupSlug'
  );

  if (slug && !isReservedRouteSegment(slug)) {
    return slug;
  } else if (querySlug) {
    return querySlug;
  } else {
    return null;
  }
};
